<template>
  <div class="Page__PaymentResult">
    <div v-if="type === 'success'" class="Module Module__Success">
      <div class="icon">
        <iconpark-icon name="circle-check"></iconpark-icon>
      </div>
      <div class="title">{{ $t('qu-xiao-ding-yue-cheng-gong') }}</div>
      <div class="operation">
        <a-button type="primary" size="large" @click="refreshHome">
          {{ $t('hui-dao-you-yan') }}
        </a-button>
      </div>
    </div>
    <div v-if="type === 'fail'" class="Module Module__Fail">
      <div class="icon">
        <iconpark-icon name="circle-close"></iconpark-icon>
      </div>
      <div class="title">{{ $t('qu-xiao-ding-yue-shi-bai') }}</div>
      <div class="operation flex gap-[20px]">
        <a-button type="primary" size="large" @click="refreshHome">
          {{ $t('hui-dao-you-yan') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { postOrderSubscriptionCancelConfirm } from '~/api/module/rights.ts';

const type = ref<'success' | 'fail'>();

const refreshHome = () => {
  location.href = `${location.origin}/subscribe`;
};

onMounted(() => {
  const cancelSecret = getQueryString('cancel_secret');

  if (cancelSecret) {
    postOrderSubscriptionCancelConfirm(cancelSecret)
      .then(() => {
        type.value = 'success';
      })
      .catch(() => {
        type.value = 'fail';
      });
  }
});
</script>

<style lang="scss" scoped>
.Page__PaymentResult {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  .Module {
    display: block;
    flex-direction: column;
    justify-content: center;
    > div {
      display: flex;
      justify-content: center;
    }
    .icon {
      font-size: 50px;
    }
    .title {
      font-weight: var(--x-weight-medium, 500);
      font-size: 32px;
      color: #050512;
      line-height: 45px;
      text-align: center;
      margin: 20px auto 12px;
    }
    .desc {
      font-size: 16px;
      color: #050512;
      line-height: 24px;
      margin: 12px auto 72px;
    }
    &__Success {
      .icon {
        color: #29e69c;
      }
    }
    &__Fail {
      .icon {
        color: #ff5656;
      }
    }
  }
}
</style>
